<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal :visible="showCreditLimitModal"
                   :data="model"
                   :title="$t('Bidding Limit')"
                   @show="onShow"
                   @hidden="onHidden"
                   @ok.prevent="handleSubmit(onSubmit)"
                   :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')"
                   :is-loading="loading"
                   scrollable>
      <b-form-checkbox
              :checked="credit_limit_checked"
              size="lg"
              class="mb-2"
              @change="onCreditLimitCheckedChange"
              switch>
        <h5 class="d-inline-block mb-0">
          {{$t('Bidding Limit')}}
        </h5>
      </b-form-checkbox>

      <currency-input-widget  v-if="credit_limit_checked"
                              :autofocus="true" ref="creditLimitInput"
                              :hint="true"
                              :label="false"
                              :model="model" attribute="credit_limit" type="number"/>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex';
  import CreditLimitForm from "../../../models/CreditLimitForm.model"
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal";
  import CurrencyInputWidget from "../../../../../core/widgets/CurrencyInputWidget";

  const {mapState, mapActions} = createNamespacedHelpers('customer/customerView');
  const {mapState: globalMapState} = createNamespacedHelpers('global');

  export default {
    name: "CreditLimitModal",
    components: {CurrencyInputWidget, ArtisioModal},
    data: () => {
      return {
        loading: false,
        credit_limit_checked: false,
        model: new CreditLimitForm({}),
        showConfirmation: false
      }
    },
    methods: {
      ...mapActions(['toggleCreditLimitModal', 'saveTermsPartialData']),
      async onSubmit() {
        this.loading = true;
        let response = await this.saveTermsPartialData({credit_limit: this.model.credit_limit});
        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          this.toggleCreditLimitModal(false);
          this.$toast('success', this.$t('Bidding Limit was successfully saved'));
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      },
      onCreditLimitCheckedChange() {
        this.credit_limit_checked = !this.credit_limit_checked;
        if (!this.credit_limit_checked) this.model.credit_limit = null;
      },
      onShow() {
        this.showConfirmation = true;
        this.credit_limit_checked = !!this.credit_limit;
        this.model = new CreditLimitForm({credit_limit: this.credit_limit || this.defaultCreditLimit});
      },
      onHidden() {
        this.model = new CreditLimitForm();
        this.toggleCreditLimitModal(false);
      },
    },
    computed: {
      ...globalMapState(['defaultCreditLimit']),
      ...mapState({
        showCreditLimitModal: state => state.termsData.showCreditLimitModal,
        credit_limit: state => state.termsData.credit_limit
      }),
    }
  }
</script>

<style scoped>

</style>